module.exports = __webpack_public_path__ + "static/media/31_32.fbae123b.mp4";